import { cn } from "~/lib/utils";

export function LogoMark({ className }: { className?: string }) {
  return (
    <img
      src="/brand/purlink-mark.png"
      alt=""
      aria-hidden
      width={32}
      height={32}
      className={cn("size-8 shrink-0 select-none", className)}
      draggable={false}
    />
  );
}

/** Mark + wordmark. The wordmark is live text so it adapts to the theme. */
export function Logo({ className, collapsed }: { className?: string; collapsed?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <LogoMark />
      <span
        className={cn(
          "text-[1.3125rem] leading-none font-semibold tracking-[-0.02em] text-lavender-600 dark:text-lavender-300",
          collapsed && "sr-only",
        )}
      >
        Purlink
      </span>
    </span>
  );
}

/** Very soft, static lavender light sources behind all content. */
export function AmbientBackground() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden print:hidden"
    >
      <div
        className="absolute -top-[20vh] -left-[10vw] size-[60vmax] rounded-full blur-3xl"
        style={{ background: "radial-gradient(closest-side, var(--ambient-1), transparent)" }}
      />
      <div
        className="absolute top-[30vh] -right-[15vw] size-[55vmax] rounded-full blur-3xl"
        style={{ background: "radial-gradient(closest-side, var(--ambient-2), transparent)" }}
      />
      <div
        className="absolute -bottom-[25vh] left-[25vw] size-[50vmax] rounded-full blur-3xl"
        style={{ background: "radial-gradient(closest-side, var(--ambient-3), transparent)" }}
      />
    </div>
  );
}
